module.exports = __webpack_public_path__ + "img/newSellerBuybox.d36babf3.svg";